var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgConceptDesign(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 64 64",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Brief_Design",
    "data-name": "Brief Design"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m60 10v2a2 2 0 0 1 -2 2h-10v-4a6 6 0 0 1 12 0z",
    fill: "#734a12",
    "data-original": "#050505",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m60 27v4.23h-6c0-4.38-.23-5.21.88-6.32a3 3 0 0 1 5.12 2.09z",
    fill: "#734a12",
    "data-original": "#050505",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m4 28v25h33zm6 12 9.06 7h-9.06z",
    fill: "#734a12",
    "data-original": "#050505",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "m41.48 17.13c-12.9-6.45-12.28-6.33-12.9-6-12.41 6.17-12.58 6.01-12.58 6.87 0 14.94-.22 14.53.55 14.89 13.25 6.62 12.24 6.25 12.85 6 5-2.49-3.46 1.74 12.05-6 .77-.36.55.07.55-14.89a1 1 0 0 0 -.52-.87zm-13.48 19.25-10-5v-11.76l10 5zm1-13.5-9.76-4.88 9.76-4.88 9.76 4.88zm11 8.5-10 5v-11.76l10-5z",
    fill: "#734a12",
    "data-original": "#050505",
    className: ""
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#050505"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m19.06 48a1 1 0 0 0 .61-1.79c-9.42-7.21-9.32-7.47-10.11-7.08s-.56.38-.56 7.87a1 1 0 0 0 1 1zm-8.06-5.94 5.12 3.94h-5.12z",
    fill: "#734a12",
    "data-original": "#050505",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m57 23a4 4 0 0 0 -4 4v28.38c0 .36 0 .2 2.22 4.54a2 2 0 0 0 3.56 0c2.28-4.41 2.22-4.2 2.22-4.54v-28.38a4 4 0 0 0 -4-4zm2 32.14-2 3.86-2-3.86v-23h4zm0-25h-4v-3.14a2 2 0 0 1 4 0z",
    fill: "#734a12",
    "data-original": "#050505",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    d: "m54 3h-38a7 7 0 0 0 -7 7v20.53l-4.4-3.33a1 1 0 0 0 -1.6.8v25a1 1 0 0 0 1 1h5v4a2.91 2.91 0 0 0 2.79 3h34.42a2.91 2.91 0 0 0 2.79-3v-43h9a3 3 0 0 0 3-3v-2a7 7 0 0 0 -7-7zm-46 48v1h-3v-3h1a1 1 0 0 0 0-2h-1v-2h1a1 1 0 0 0 0-2h-1v-2h1a1 1 0 0 0 0-2h-1v-2h1a1 1 0 0 0 0-2h-1v-5l29 22h-8v-1a1 1 0 0 0 -2 0v1h-2v-1a1 1 0 0 0 -2 0v1h-2v-1a1 1 0 0 0 -2 0v1h-2v-1a1 1 0 0 0 -2 0v1h-2v-1a1 1 0 0 0 -2 0zm39-41v48a.93.93 0 0 1 -.79 1h-34.42a.93.93 0 0 1 -.79-1v-4h26a1 1 0 0 0 .6-1.8c-28.01-21.2-26.6-20.1-26.6-20.2v-22a5 5 0 0 1 5-5h33.11a7 7 0 0 0 -2.11 5zm12 2a1 1 0 0 1 -1 1h-9v-3a5 5 0 0 1 10 0z",
    fill: "#734a12",
    "data-original": "#050505",
    className: ""
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConceptDesign);
export default __webpack_public_path__ + "static/media/concept_design.44fa075cc32ca887e07c6cae1811edcb.svg";
export { ForwardRef as ReactComponent };